export default "__VITE_ASSET__Cwxht959__"